// extracted by mini-css-extract-plugin
export default {"main":"CartItemList_main__RBL2g","productGroup":"CartItemList_productGroup__DIdNp"};